<div class="container-fluid">
  <div class="row">
    <app-chart-widget
      [widgetPanelCharts]="widgetPanelCharts"
      [widgetPanel]="{ style: {} }"
      [title]="'Vendor Trades'"
    >
      <p
        class="text-center vive-blue text-decoration-underline"
        (click)="showMoreLessTrades()"
      >
        Show {{ showMoreTrades ? 'Less' : 'More' }} Trades
      </p>
    </app-chart-widget>
  </div>
</div>
